<template>
    <div class="navbar">
        <h2>
            <i class="iconfont icon-baojing1"></i>&nbsp;{{$t('menu4')}}
            <Divider type="vertical" style="background-color:#aaa;" />
            <small>{{$t('alarmSubTitle')}}</small>
        </h2>
    </div>
</template>
<script>
export default {
    data() {
        return {};
    }
};
</script>



// WEBPACK FOOTER //
// src/views/alarm/components/navbar.vue